export default __webpack_public_path__ + "img/20200e5bcbbdbfa39ef53706ddb29482.svg";